/**
 * levelName - nazwa lub numer poziomu(extra, 1, 3)
 * type - typ modala: unlockLevel, unlockExtraLevel, error
 * screen- na jakim ekranie powinien się wyświetlić
 */

import {getTranslation} from "./get-translation";

export const TYPE_CONFIRM_RESET_DATABASE = "TYPE_CONFIRM_RESET_DATABASE";
export function confirmResetDatabaseModal(){
	return {
		type: TYPE_CONFIRM_RESET_DATABASE,
		bodyText: getTranslation("modal_reset_database_body"),
		confirmButtonText: getTranslation("modal_reset_database_confirm_button"),
		cancelButtonText: getTranslation("modal_reset_database_cancel_button"),
		screen: ''
	}
}

export const TYPE_CONFIRM_DELETE = "TYPE_CONFIRM_DELETE";
export function confirmDeleteModal(){
	return {
		type: TYPE_CONFIRM_DELETE,
		bodyText: getTranslation("modal_delete_body"),
		confirmButtonText: getTranslation("modal_delete_confirm_button"),
		cancelButtonText: getTranslation("modal_delete_cancel_button"),
		screen: ''
	}
}

export const TYPE_CONFIRM_RESET_PASSWORD = "TYPE_CONFIRM_RESET_PASSWORD";
export function confirmResetPasswordModal(){
	return {
		type: TYPE_CONFIRM_RESET_PASSWORD,
		bodyText: getTranslation("modal_reset_password_body"),
		confirmButtonText: getTranslation("modal_reset_password_confirm_button"),
		cancelButtonText: getTranslation("modal_reset_password_cancel_button"),
		screen: ''
	}
}

export const TYPE_ERROR = "TYPE_ERROR";
export function errorModal(key, hasHtml = false){
	const translation = getTranslation(key);
	return {
		type: TYPE_ERROR,
		message: translation,
		screen: '',
		hasHtml
	}
}

export const TYPE_INFO = "TYPE_INFO";
export function infoModal(key){
	const translation = getTranslation(key);
	return {
		type: TYPE_INFO,
		message: translation,
		screen: ''
	}
}

export const TYPE_UNLOCK_LEVEL = "TYPE_UNLOCK_LEVEL";
export function unlockLevelModal({levelName, unlockedLevel}){
	return {
		type: TYPE_UNLOCK_LEVEL,
		titleText: getTranslation("modal_level_title"),
		bodyText: getTranslation("modal_level_body", [levelName]),
		congratulationsText: getTranslation("modal_congratulation"),
		hintsText: getTranslation("modal_level_hints"),
		buttonText: getTranslation("modal_level_button", [levelName]),
		unlockedLevel,
		screen: 'game'
	}
}

export const TYPE_EXTRA_UNLOCK_LEVEL = "TYPE_EXTRA_UNLOCK_LEVEL";
export function unlockExtraLevelModal({ levelName, levelIcon }){
	return {
		type: TYPE_EXTRA_UNLOCK_LEVEL,
		titleText: getTranslation("modal_extra_level_title", [capitalize(levelName)]),
		bodyText: getTranslation("modal_extra_level_body"),
		congratulationsText: getTranslation("modal_congratulation"),
		buttonText: getTranslation("modal_extra_level_button"),
		levelName,
		levelIcon,
		screen: 'game'
	}
}

export const TYPE_HINTS = "TYPE_HINTS";
export function hintsModal(){
	return {
		type: TYPE_HINTS,
		screen: 'game'
	}
}

export const TYPE_WHEEL = "TYPE_WHEEL";
export function wheelModal(){
	return {
		type: TYPE_WHEEL,
		spinButtonText: getTranslation("modal_wheel_spin_text"),
		claimButtonText: getTranslation("modal_wheel_claim_text"),
		screen: ''
	}
}

function capitalize(s){
	return s[0].toUpperCase() + s.slice(1);
}